import { BrowserRouter, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import Notes from './pages/Notes';
import Settings from './pages/Settings';
import { Home as HomeIcon, FileText, Settings as SettingsIcon } from 'lucide-react';
import './App.css';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="gradient-bg" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <p style={{ color: '#00F0FF' }}>Carregando...</p>
      </div>
    );
  }

  return user ? <>{children}</> : <Navigate to="/login" />;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="gradient-bg" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <p style={{ color: '#00F0FF' }}>Carregando...</p>
      </div>
    );
  }

  return user ? <Navigate to="/" /> : <>{children}</>;
}

function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <nav className="bottom-nav">
        <NavLink
          to="/"
          className={({ isActive }: { isActive: boolean }) => `nav-item ${isActive ? 'active' : ''}`}
          end
        >
          <HomeIcon size={24} />
          <span className="nav-label">Criar</span>
        </NavLink>
        <NavLink
          to="/notes"
          className={({ isActive }: { isActive: boolean }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          <FileText size={24} />
          <span className="nav-label">Notas</span>
        </NavLink>
        <NavLink
          to="/settings"
          className={({ isActive }: { isActive: boolean }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          <SettingsIcon size={24} />
          <span className="nav-label">Config</span>
        </NavLink>
      </nav>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Home />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/notes"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Notes />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Settings />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
